import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BasicSnackbarComponent } from './basic-snackbar.component';

@NgModule({
  declarations: [BasicSnackbarComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    TranslateModule.forChild(),
  ],
  exports: [BasicSnackbarComponent],
})
export class BasicSnackbarSharedModule {}
